import {
  type PropsWithChildren,
  type SetStateAction,
  useMemo,
  useState,
} from "react";

import type { FlightSearchFormValues } from "@/features/flights/utils/flightsValidation";

import { FlightSearchDataContext } from "./FlightSearchDataContext";

export const FlightSearchDataProvider = ({ children }: PropsWithChildren) => {
  const [searchData, setSearchData] = useState<FlightSearchFormValues | null>(
    null,
  );

  const contextValue = useMemo(
    () => ({
      searchData,
      updateSearchData: (
        data: SetStateAction<FlightSearchFormValues | null>,
      ) => {
        window.dispatchEvent(new CustomEvent("searchdataupdated"));
        setSearchData(data);
      },
    }),
    [searchData, setSearchData],
  );

  return (
    <FlightSearchDataContext.Provider value={contextValue}>
      {children}
    </FlightSearchDataContext.Provider>
  );
};
